<template>
  <v-container fluid>
    <payroll-government-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollGovernmentReportContainerView: () => import('@/components/hris/payroll/report/GovernmentReport'),
    },
  }
</script>
